<template>
    <div class="popup-background">
        <div class="popup">
            <div class="popup__header">
                <img src="../../../assets/symbols/close-ico.svg" @click="$emit('cancel')"/>
            </div>
            <div class="popup__body">
                <div class="form-group select-group" :class="{ 'input-error': $v.data.type.$error}">
                    <p>1. Wybierz kategorię*</p>
                    <vueselect class="select--list" :clearable="false" :searchable="false" :options="typesList" label="name" v-model="data.type">
                    <template slot="no-options">
                        <p>Brak rekordów</p>
                    </template>
                    </vueselect>
                    <labelInfo class="custom-error-label" v-if="!$v.data.type.required" type="error" message="To pole jest wymagane"/>
                </div>
                <div class="form-group">
                    <p>2. Prześlij grafiki*</p>
                    <fileUpload :addtionalData="data" :stepUploadAdd="addFiles" @success="addData($event)" @error="uploadError = true; addFiles = false" @count="filesCount = $event"/>
                </div>
                <div v-if="data.type.code" class="form-group custom-group">
                    <div class="row">
                        <div class="col">
                            <label><p>3. Uzupełnij dane</p></label>
                        </div>
                    </div>
                    <div class="row" v-if="data.type.code == 'Packshot'">
                        <div class="row">
                            <div class="col col-4">
                                <div class="form-group" :class="{ 'input-error': $v.data.index.$error && validateStep.cat1 }">
                                    <label>Nr artykułu*</label>
                                    <input class="form-control form-control-lg" type="text" v-model="data.index"/>
                                    <labelInfo v-if="!$v.data.index.required" type="error" message="To pole jest wymagane"/>
                                    <labelInfo v-if="!$v.data.index.numeric" type="error" message="To pole musi być liczbą"/>
                                </div>
                            </div>
                            <div class="col col-8">
                                <div class="form-group">
                                    <label>EAN</label>
                                    <input class="form-control form-control-lg" type="text" v-model="data.ean"/>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-4">
                                <div class="form-group" :class="{ 'input-error': $v.data.producer.$error && validateStep.cat1 }">
                                    <label>Producent*</label>
                                    <input class="form-control form-control-lg" type="text" v-model="data.producer"/>
                                    <labelInfo v-if="!$v.data.producer.required" type="error" message="To pole jest wymagane"/>
                                </div>
                            </div>
                            <div class="col col-8">
                                <div class="form-group" :class="{ 'input-error': $v.data.keywords.$error && validateStep.cat1 }">
                                    <label>Słowa kluczowe*</label>
                                    <input class="form-control form-control-lg" type="text" v-model="data.keywords"/>
                                    <labelInfo v-if="!$v.data.keywords.required" type="error" message="To pole jest wymagane"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" v-if="data.type.code == 'Logo'">
                        <div class="row">
                            <div class="col col-4">
                                <div class="form-group" :class="{ 'input-error': $v.data.producer.$error && validateStep.cat2 }">
                                    <label>Producent*</label>
                                    <input class="form-control form-control-lg" type="text" v-model="data.producer"/>
                                    <labelInfo v-if="!$v.data.producer.required" type="error" message="To pole jest wymagane"/>
                                </div>
                            </div>
                            <div class="col col-8">
                                <div class="form-group" :class="{ 'input-error': $v.data.keywords.$error && validateStep.cat2 }">
                                    <label>Słowa kluczowe*</label>
                                    <input class="form-control form-control-lg" type="text" v-model="data.keywords"/>
                                    <labelInfo v-if="!$v.data.keywords.required" type="error" message="To pole jest wymagane"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" v-if="data.type.code == 'Ikonka' || data.type.code == 'Karta_prepaid'">
                        <div class="row">
                            <div class="col col-4">
                                <div class="form-group">
                                    <label>Producent</label>
                                    <input class="form-control form-control-lg" type="text" v-model="data.producer"/>
                                </div>
                            </div>
                            <div class="col col-8">
                                <div class="form-group" :class="{ 'input-error': $v.data.keywords.$error && validateStep.cat3 }">
                                    <label>Słowa kluczowe*</label>
                                    <input class="form-control form-control-lg" type="text" v-model="data.keywords"/>
                                    <labelInfo v-if="!$v.data.keywords.required" type="error" message="To pole jest wymagane"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" v-if="data.type.code == 'Tytus'">
                        <div class="row">
                            <div class="col">
                                <div class="form-group" :class="{ 'input-error': $v.data.keywords.$error && validateStep.cat4 }">
                                    <label>Słowa kluczowe*</label>
                                    <input class="form-control form-control-lg" type="text" v-model="data.keywords"/>
                                    <labelInfo v-if="!$v.data.keywords.required" type="error" message="To pole jest wymagane"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" v-if="data.type.code == 'Inne'">
                        <div class="row">
                            <div class="col col-4">
                                <div class="form-group" :class="{ 'input-error': $v.data.index.$error && $v.data.index.required && validateStep.cat4 }">
                                    <label>Nr artykułu</label>
                                    <input class="form-control form-control-lg" type="text" v-model="data.index"/>
                                    <labelInfo v-if="!$v.data.index.numeric && $v.data.index.required" type="error" message="To pole musi być liczbą"/>
                                </div>
                            </div>
                            <div class="col col-8">
                                <div class="form-group">
                                    <label>EAN</label>
                                    <input class="form-control form-control-lg" type="text" v-model="data.ean"/>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-4">
                                <div class="form-group">
                                    <label>Producent</label>
                                    <input class="form-control form-control-lg" type="text" v-model="data.producer"/>
                                </div>
                            </div>
                            <div class="col col-8">
                                <div class="form-group" :class="{ 'input-error': $v.data.keywords.$error && validateStep.cat4 }">
                                    <label>Słowa kluczowe*</label>
                                    <input class="form-control form-control-lg" type="text" v-model="data.keywords"/>
                                    <labelInfo v-if="!$v.data.keywords.required" type="error" message="To pole jest wymagane"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="showFields && data.type.code" class="form-group select-group" :class="{ 'input-error': $v.newfield.$error}">
                    <p>4. Pokaż w produkcie jako*</p>
                    <vueselect class="select--list" :clearable="false" :searchable="false" :options="fieldsList" label="name" v-model="newfield">
                    <template slot="no-options">
                        <p>Brak rekordów</p>
                    </template>
                    </vueselect>
                    <labelInfo v-if="!$v.newfield.required" type="error" message="To pole jest wymagane"/>
                </div>
            </div>
            <div class="popup__footer">
                <p v-if="uploadError">Błąd wysyłania zdjęć</p>
                <p v-if="logoAllert">Jako logo możesz przesłać tylko jedną grafikę</p>
                <p v-if="noFiles">Brak wybranych plików</p>
                <button class="button-normal button-normal--media" :class="{'disabled' : logoAllert}" @click="validateCategory()">Prześlij</button>
                <span>*pola wymagane</span>
            </div>
        </div>
    </div>
</template>

<script>

import { validationMixin } from 'vuelidate'
import { required, maxLength, numeric } from 'vuelidate/lib/validators'

import fileUpload from './fileUpload'
import labelInfo from '@/components/blocks/labelInfo.vue'

export default {
    
    name: 'filePopup',
    components:{

        fileUpload,
        labelInfo

    },
    props:{

        showFields:{
            type: Boolean,
            default: false,
        }

    },
    mixins: [validationMixin],
    watch:{

        filesCount(){

            if(this.filesCount > 0) this.noFiles = false;
            this.data.type.code == 'Logo' && this.showFields && this.filesCount > 1 ? this.logoAllert = true : this.logoAllert = false;

        },

    },
    data(){

        return{

            data:{
                type: '',
                index: '',
                ean: '',
                producer: '',
                keywords: '',
            },

            newfield: null,

            type: 'packshot',

            addFiles: false,
            uploadError: false,
            logoAllert: false,
            noFiles: false,

            typesList: [],
            filesCount: 0,

            fieldsList:[
                {name: 'Logo główne', code: 'logo'},
                {name: 'Logo dodatkowe', code: 'logo_addtional'},
                {name: 'Wybrane grafiki', code: 'selected'},
                {name: 'Ikony', code: 'icons'},
                {name: 'Znak wodny', code: 'watermark'},
                {name: 'Nieokreślone', code: 'unset'}
            ],

            validateStep:{
                cat1: false,
                cat2: false,
                cat3: false,
                cat4: false,
            }

        }

    },
    validations: {
        
        newfield: {
          required,
        },
        data:{
            type: {required},
            index: {required, numeric},
            keywords: {required},
            producer: {required}
        },
    },
    methods:{

        addData(e){

            const token = localStorage.getItem('auth_token');

            this.data.local_id = e.hash;
            this.data.type = this.data.type.id;

            this.$http.post(`product-image-files/information`, this.data, {
            headers: {

            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'

            }})
            .then(response => {

                const callback = {
                    field: this.newfield,
                    images: e.images
                }

                this.$emit('confirm', callback);

            })
            .catch(error => {

                console.error(error.response);

            })

        },

        validateCategory(){

            this.uploadError = false;
            this.noFiles = false;
            
            this.validateStep.cat1 = false;
            this.validateStep.cat2 = false;
            this.validateStep.cat3 = false;
            this.validateStep.cat4 = false;

            if(this.data.type.code == 'Packshot'){

                this.validateStep.cat1 = true;

            }

            if(this.data.type.code == 'Logo'){

                this.validateStep.cat2 = true;

            }

            if(this.data.type.code == 'Ikonka' || this.data.type.code == 'Karta_prepaid'){

                this.validateStep.cat3 = true;

            }

            if(this.data.type.code == 'Tytus' || this.data.type.code == 'Inne'){

                this.validateStep.cat4 = true;

            }

            this.$v.$touch();

            //const inputs = document.querySelectorAll('.form-group');
            let valid;

            window.setTimeout(() =>{

                if(!document.querySelector('.input-error') && this.filesCount > 0){

                    valid = true;
                  
                }else{

                    if(!this.filesCount > 0) this.noFiles = true;

                }

                if(valid){

                    this.addFiles = true

                }

            }, 100)

        },

        getFormData(){

            const token = localStorage.getItem('auth_token');

            this.$http.get(`product-image-file/types`, {
            headers: {

            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'

            }})
            .then(response => {

                this.typesList;
                response.data.categories.forEach(item =>{

                    if(item.code == 'Packshot' || item.code == 'Inne' || item.code == 'Logo' || item.code == 'Ikonka' || item.code == 'Tytus' || item.code == 'Karta_prepaid'){

                        this.typesList.push(item);

                    }

                });

            })
            .catch(error => {

                console.error(error.response);

            })

        },

    },
    mounted(){

        this.getFormData();

    }

}

</script>

<style lang="scss">

.popup-background{
    display:flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    width:100%;
    height:100%;
    top:0;
    left:0;
    background: rgba(0, 0, 0, 0.274);
    z-index: 2000;

    .popup{
        display:flex;
        flex-direction: column;
        width:510px;
        padding:30px;
        background: #fff;
        border: 1px solid #e02020;
        margin-top: -140px;

        .select-group{
            width:50%;
        }

        label{
            margin-top: 10px;
        }

        .form-group.input-error > input, .form-group.input-error .vs__dropdown-toggle{
            height:auto !important;
            padding: 0px !important;
        }

        &__header{
            display:flex;
            align-items: center;
            justify-content: flex-end;
            width:100%;

            img{
                display:block;
                width:12px;
                cursor: pointer;
            }
        }

        &__footer{
            display:flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            position: relative;

            p{
                color: #e3000b;
                margin: 10px 0px;
            }

            span{
                position:absolute;
                bottom:0;
                left:0;
                font-size: 10px;
            }
        }
    }
}

.custom-group{

    .col{
        padding:0;
        padding-right: 20px;
    }
}

.custom-error-label{
    margin-right: 5px;
    margin-top: -18px !important;
}

</style>